import {useGetChangeSGNoteData, useSaveNote, useGetSGEquipmentsTree, useGetSendEmailsToSPData, usePostSendEmailsToSPData, useGetChangeLangData, usePostUnsubscribeEmailNotificationData, useGetUnsubscribeFormData, usePostUnsubscribeForm, useGetSGLogsEmailBody} from "./requests";

const useSupplierGeographyApi = () => {
    const {
        isLoading: getChangeNoteDataIsLoading,
        cancel: cancelGetChangeNoteData,
        getChangeNoteData
    } = useGetChangeSGNoteData();

    const {
        isLoading: saveNoteIsLoading,
        cancel: cancelSaveNote,
        saveNote
    } = useSaveNote();

    const {
        isLoading: getSGEquipmentsTreeIsLoading,
        cancel: cancelGetSGEquipmentsTree,
        getSGEquipmentsTree
    } = useGetSGEquipmentsTree();

    const {
        isLoading: getSendEmailsToSPDataIsLoading,
        cancel: cancelGetSendEmailsToSPData,
        getSendEmailsToSPData
    } = useGetSendEmailsToSPData();

    const {
        isLoading: postSendEmailsToSPDataIsLoading,
        cancel: cancelPostSendEmailsToSPData,
        postSendEmailsToSP
    } = usePostSendEmailsToSPData();

    const {
        isLoading: getChangeLangDataIsLoading,
        cancel: cancelGetChangeLangData,
        getChangeLangData
    } = useGetChangeLangData();

    const {
        isLoading: postUnsubscribeEmailNotificationDataIsLoading,
        cancel: cancelPostUnsubscribeEmailNotificationData,
        postUnsubscribeEmailNotification
    } = usePostUnsubscribeEmailNotificationData();

    const {
        isLoading: getUnsubscribeFormDataIsLoading,
        cancel: cancelGetUnsubscribeFormData,
        getUnsubscribeFormData
    } = useGetUnsubscribeFormData();

    const {
        isLoading: postUnsubscribeFormIsLoading,
        cancel: cancelPostUnsubscribeForm,
        postUnsubscribeForm
    } = usePostUnsubscribeForm();

    const {
        isLoading: getSGLogsEmailBodyIsLoading,
        cancel: cancelGetSGLogsEmailBody,
        getSGLogsEmailBody
    } = useGetSGLogsEmailBody();

    return {
        getChangeNoteData: {
            query: getChangeNoteData,
            isLoading: getChangeNoteDataIsLoading,
            cancel: cancelGetChangeNoteData
        },
        saveNote: {
            mutation: saveNote,
            isLoading: saveNoteIsLoading,
            cancel: cancelSaveNote
        },
        getSGEquipmentsTree: {
            query: getSGEquipmentsTree,
            isLoading: getSGEquipmentsTreeIsLoading,
            cancel: cancelGetSGEquipmentsTree
        },

        getSendEmailsToSPData: {
            query: getSendEmailsToSPData,
            isLoading: getSendEmailsToSPDataIsLoading,
            cancel: cancelGetSendEmailsToSPData
        },
        postSendEmailsToSPData: {
            query: postSendEmailsToSP,
            isLoading: postSendEmailsToSPDataIsLoading,
            cancel: cancelPostSendEmailsToSPData
        },

        getChangeLangData: {
            query: getChangeLangData,
            isLoading: getChangeLangDataIsLoading,
            cancel: cancelGetChangeLangData
        },
        postUnsubscribeEmailNotificationData: {
            query: postUnsubscribeEmailNotification,
            isLoading: postUnsubscribeEmailNotificationDataIsLoading,
            cancel: cancelPostUnsubscribeEmailNotificationData
        },
        getUnsubscribeFormData: {
            query: getUnsubscribeFormData,
            isLoading: getUnsubscribeFormDataIsLoading,
            cancel: cancelGetUnsubscribeFormData
        },

        postUnsubscribeForm: {
            mutation: postUnsubscribeForm,
            isLoading: postUnsubscribeFormIsLoading,
            cancel: cancelPostUnsubscribeForm
        },
        getSGLogsEmailBody: {
            query: getSGLogsEmailBody,
            isLoading: getSGLogsEmailBodyIsLoading,
            cancel: cancelGetSGLogsEmailBody
        },
    };
};

export default useSupplierGeographyApi;